import {
  useEventingContext
} from "@/context/eventing"
import {
  ConfigurableProduct
} from "@/types/graphql.prod"

export const useGTM = ({
  item
}:{
  item: ConfigurableProduct
}) => {
  const finalPrice = item?.price_range?.maximum_price?.final_price?.value

  const discountAmount =
  item?.price_range?.maximum_price?.discount?.amount_off

  const currencyCode = item?.price_range?.maximum_price?.final_price?.currency


  const [, {
    dispatch 
  }] = useEventingContext()

  const handleLinkClick = () => {
    dispatch({
      type: "PRODUCT_CLICK",
      payload: {
        name: item.name,
        sku: item.sku,
        priceTotal: finalPrice,
        discountAmount,
        currencyCode,
        selectedOptions: null,
      },
    })

    if (item) {
      try {
        (window as any).dataLayer && (window as any).dataLayer.push({
          ecommerce: null 
        })(window as any).dataLayer &&
                    (window as any).dataLayer.push({
                      event: "select_item",
                      ecommerce: {
                        items: [
                          {
                            item_name: item.name,
                            item_id: item.sku,
                            price:
                                        item?.price_range?.minimum_price
                                          ?.final_price?.value ||
                                        item?.price_range?.maximum_price
                                          ?.final_price?.value,
                            quantity: 1,
                          },
                        ],
                      },
                    })
      } catch (err) {
        console.error(err)
      }
    }
  }

  return {
    handleLinkClick
  } 
}
